import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';

function AccessDeniedPage({
    title = 'Acceso denegado',
    description = 'No tenes permisos para acceder a esta seccion.',
}) {
    return (
        <Box
            sx={{
                minHeight: '70vh',
                display: 'grid',
                placeItems: 'center',
                p: 2,
            }}
        >
            <Paper sx={{ p: 3, maxWidth: 480, width: '100%' }}>
                <Stack spacing={2}>
                    <Typography variant="h5" component="h1" fontWeight={700}>
                        {title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {description}
                    </Typography>
                    <Stack direction="row" spacing={1.25}>
                        <Button component={RouterLink} to="/dashboard" variant="contained">
                            Ir al dashboard
                        </Button>
                        <Button component={RouterLink} to="/login" variant="outlined">
                            Ir a login
                        </Button>
                    </Stack>
                </Stack>
            </Paper>
        </Box>
    );
}

export default AccessDeniedPage;
